module.exports = __webpack_public_path__ + "img/icon-swiper-left.b553c156.png";